import { createSelector } from 'reselect';
import _ from 'lodash';

export const appIsFetchingSelector = createSelector(
    state => _.get(state, 'loadingBlock.queueOfRequests'),
    queue => queue > 0
);
